import { render } from "./PlayBox.vue?vue&type=template&id=373dadab"
import script from "./PlayBox.vue?vue&type=script&lang=js"
export * from "./PlayBox.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/PlayBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "373dadab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('373dadab', __exports__)) {
    api.reload('373dadab', __exports__)
  }
  
  module.hot.accept("./PlayBox.vue?vue&type=template&id=373dadab", () => {
    api.rerender('373dadab', render)
  })

}


export default __exports__